/**
 * Custom Form Container
 * @author Kate York
 * TODO: This is a fix for issue on STRONE-1156. Bug reported to Episerver and should be fixed in next release of forms. That means this is no longer required.
 * Date Fixed: 20/10/2010
 */

// Utilities
import debug from "debug";
import plugin from '../../lib/plugin';
const log = debug('core/modules/forms/episerver-forms-anchor-fix');

const ELEMENT_SELECTOR ='.EPiServerForms';
const FORM_STEP_SELECTOR = '.FormStep';

class EpiserverFormsAnchorFix {

	constructor (element) {
		this.element = element;
		this.$element = $(element);	
		this.watch();
	}

	watch() {
        var obj = this;
        if(window.location.hash && this.$element.find(FORM_STEP_SELECTOR).length > 0) {
            if (typeof $$epiforms !== 'undefined') {
                $$epiforms(document).ready(function myfunction() {				
                    var hash = window.location.hash;
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, 1000);
                });
            }
        }
	}
}

plugin('episerverFormsAnchorFix', EpiserverFormsAnchorFix);

// Export
export function exec () {
	$(document).ready( () => {
		log('binding');
		$(ELEMENT_SELECTOR).episerverFormsAnchorFix();
		log('bound');
	});
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/forms/episerver-forms-anchor-fix.js